import type { DreAccountLineDto, DreByAccountDto, DreByAccountLineDto } from "@bi/types";

export const lineOf = (d: DreByAccountDto, key: string): DreByAccountLineDto | undefined =>
  d.lines.find((l) => l.key === key);

/** Os quatro números da cascata que viram cartão. */
export function dreAccountKpis(d: DreByAccountDto) {
  const v = (k: string) => lineOf(d, k)?.value ?? 0;
  const p = (k: string) => lineOf(d, k)?.pctOfRevenue ?? null;
  return {
    netRevenue: v("receita_liquida"),
    contribution: v("margem_contribuicao"),
    contributionPct: p("margem_contribuicao"),
    ebitda: v("ebitda"),
    ebitdaPct: p("ebitda"),
    result: d.resultado,
    resultPct: p("resultado"),
  };
}

/** Linha em que a conta está hoje (para o seletor de reclassificação). */
export function accountLineKey(lineKey: string): string {
  return lineKey === "a_classificar" ? "" : lineKey;
}

/** Quantas contas foram classificadas manualmente (gravadas) vs. pela regra. */
export function classificationCounts(d: DreByAccountDto): { manual: number; regra: number; semLinha: number } {
  const all: DreAccountLineDto[] = [...d.lines.flatMap((l) => l.accounts), ...d.outside.accounts];
  const semLinha = lineOf(d, "a_classificar")?.accounts.length ?? 0;
  return {
    manual: all.filter((a) => a.classifiedBy === "manual").length,
    regra: all.filter((a) => a.classifiedBy === "regra").length - semLinha,
    semLinha,
  };
}

/** "−R$ 1.234,00" com o sinal tipográfico, para a cascata. */
export function signedBRL(v: number, fmt: (n: number) => string): string {
  if (Math.abs(v) < 0.005) return fmt(0);
  return v < 0 ? `−${fmt(Math.abs(v))}` : fmt(v);
}
